import {ErrorType} from '../types'

/**
 * Checks if the error relates to a failed dynamic import (chunk loading).
 * This typically occurs when the app is updated and the client has stale assets.
 */
export const isLoadChunkError = (error: Error): boolean => {
    return error?.message?.includes('Loading chunk') && error?.message?.includes('failed')
}

/**
 * Detects runtime TypeErrors that surface as uncaught errors in React.
 */
export const isUncaughtTypeError = (error: Error): boolean => {
    const name = error?.name || ''
    const stack = error?.stack || ''

    if (name === 'TypeError') return true
    return /TypeError/i.test(stack)
}

export const getErrorType = (error: Error): ErrorType => {
    if (isLoadChunkError(error)) return 'LoadChunk'
    if (isUncaughtTypeError(error)) return 'TypeError'
    return 'AuthError'
}

export const getErrorTypeLabel = (errorType: ErrorType): string => {
    switch (errorType) {
        case 'LoadChunk':
            return 'Chunk Load Failure'
        case 'TypeError':
            return 'Uncaught TypeError'
        case 'AuthError':
            return 'Authorization Error'
        default:
            return 'Unknown Error Type'
    }
}
